'use client';

import { c as _c } from "react/compiler-runtime";
import { GlobalErrorBody, type GlobalErrorProps } from '@libs/shared-ui';
export default function ErrorPage(t0) {
  const $ = _c(3);
  const {
    error,
    reset
  } = t0;
  let t1;
  if ($[0] !== error || $[1] !== reset) {
    t1 = <GlobalErrorBody reset={reset} error={error} />;
    $[0] = error;
    $[1] = reset;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}